import type { Friend } from "@/lib/api/models/social";

export const FRIENDS_QUERY_KEY = ["me", "friends"] as const;

/** How a person is named on the web: by handle, since there is no address book here. */
export function friendName(friend: Friend): string {
  return friend.username ? `@${friend.username}` : "Someone";
}
